/**
 * 校验Bridge/Event的入参
 * @param method Bridge的方法名, event没有入参
 * @param data 业务方传入的参数
 */
export function validateReq(method, schemaType, data) {
    if (process.env.BUILD_ENV !== 'production') {
        const validateData = (data || {});
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const validate = require('../validator').validate;
        validate(method, validateData, schemaType, 'args');
    }
}
/**
 * 校验Bridge/Event的返回值
 * @param method Bridge的方法名或者事件名
 * @param data 客户端的返回值
 */
export function validateRes(method, schemaType, data) {
    if (process.env.BUILD_ENV !== 'production') {
        const validateData = (data || {});
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const validate = require('../validator').validate;
        validate(method, validateData, schemaType, 'res');
    }
}
